/**
 * The shared maneuver color legend's measured height.
 *
 * The five maneuver report pages size .maneuver-map-layout and #datatable-big-wrapper from
 * window.innerHeight minus a set of constants; the legend row sits above both and wraps to a
 * different number of rows per color mode, so its height has to be measured rather than guessed —
 * a sixth constant would be wrong the moment the mode changes. One module rather than five copies
 * of the same getElementById.
 */

export const MANEUVER_COLOR_LEGEND_ROW_ID = 'maneuver-color-legend-row';

/** Layout height of the legend row, or 0 when it is not mounted. Pre-transform, like offsetHeight. */
export function maneuverColorLegendReservePx(): number {
  if (typeof document === 'undefined') {return 0;}
  const el = document.getElementById(MANEUVER_COLOR_LEGEND_ROW_ID);
  return el ? el.offsetHeight : 0;
}

/**
 * Painted height of the legend row, or 0 when it is not mounted.
 *
 * The post-transform measurement, for callers working in the same units as `window.innerHeight` —
 * the maneuver chart height math, which sits under `#media-container`'s `scale()`. Kept distinct
 * from `maneuverColorLegendReservePx` on purpose: mixing the two under a non-1 scale factor is what
 * makes a chart stack come out slightly too tall or too short.
 */
export function maneuverColorLegendRenderedPx(): number {
  if (typeof document === 'undefined') {return 0;}
  const el = document.getElementById(MANEUVER_COLOR_LEGEND_ROW_ID);
  return el ? Math.ceil(el.getBoundingClientRect().height) : 0;
}
